import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ValidationMessagesComponent} from "./validation-messages.component";
import {ValidationService} from "./validation.service";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ValidationMessagesComponent],
  providers: [ValidationService],
  exports: [ValidationMessagesComponent]
})
export class ValidationMessagesModule { }



// WEBPACK FOOTER //
// ./src/app/core/validation-messages/validation-messages.module.ts